import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';

import DurationFormatter from '../utils/duration';

require.ensure([], () => {
    require('./PMO.less');
});

class WeekPill extends React.Component {

    constructor(props, context) {
        super(props, context);
    }
    // EVENT HANDLERS

    handleClick = () => {
        this.props.handleClick(this.props.week);
    }

    // RENDER METHOD

    render = () => {
        let weekRange = moment(this.props.week);
        let firstDay = weekRange.day(1);
        let lastDay = firstDay.clone().add(6, 'd');
        let weekRangeString = firstDay.format("D.M.") + " - " + lastDay.format("D.M.") + " " + lastDay.year();

        if (!this.props.active) {
            return (
                <div className="panel panel-default panel-pmtask">
                    <div className="panel-heading" role="tab" id="headingOne">
                        <h4 className="panel-title">
                        <a onClick={this.handleClick} className="clearfix" style={{wordWrap : "break-word", "cursor" : "pointer"}} data-toggle="collapse" data-parent="#accordion" aria-expanded="true" aria-controls="collapseOne">
                            <span className="md-expand-more"></span>
                            &nbsp;{weekRangeString}
                        </a>
                        </h4>
                    </div>
                </div>
            );
        } else {
            return (
                <div className="panel panel-default panel-pmtask">
                    <div className="panel-heading" role="tab" id="headingOne">
                        <h4 className="panel-title">
                        <a onClick={this.handleClick} className="clearfix" style={{wordWrap : "break-word", "cursor" : "pointer"}} data-toggle="collapse" data-parent="#accordion" aria-expanded="true" aria-controls="collapseOne">
                            <span className="md-chevron-right"></span>
                            {weekRangeString}
                        </a>
                        </h4>
                    </div>
                    <div className="panel-body">
                        <table className="table table-condensed">
                            <thead>
                                <tr>
                                    <th>Worker</th>
                                    <th>Task</th>
                                    <th>Time total</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    Object.keys(this.props.approvableHours).map((key, i) => {
                                        let approvableHour = this.props.approvableHours[key];
                                        return <tr key={i}>
                                                    <td>{approvableHour.user}</td>
                                                    <td>{approvableHour.task}</td>
                                                    <td>{DurationFormatter.format(approvableHour.timeTotal)}{approvableHour.timeOvertime && approvableHour.timeOvertime > 0 ? "(+ " + DurationFormatter.format(approvableHour.timeOvertime) + ")" : ""}</td>
                                                </tr>;
                                    })
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
            );
        }
    }
}

WeekPill.propTypes = {
    active: PropTypes.bool,
    approvableHours: PropTypes.array,
    handleClick: PropTypes.func,
    id: PropTypes.number,
    week: PropTypes.string,
};

export default connect()(WeekPill);



/** WEBPACK FOOTER **
 ** ./src/app/components/WeekPill.js
 **/